import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const CustomLoaderIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;

  // Dynamically set size and color through props
  const { size = "medium" } = props;

  const predefinedSizes = {
    small: themeValue?.fontSmlSize?.size || 24,
    medium: themeValue?.fontMediumSize?.size || 48,
    large: themeValue?.fontLgSize?.size || 72,
  };

  const finalSize = predefinedSizes[size] || predefinedSizes.medium;

  // Determine color from theme, fallback to default if not available
  const color =
    themeValue?.iconColor || themeDefault?.info?.colorPrimary || "#000"; // Fallback to black if not found

  useEffect(() => {
    const styles = `
      .loader {
        border-radius: 50%;
        display: inline-block;
        position: relative;
        border: 3px solid;
        box-sizing: border-box;
        animation: rotation 1.5s linear infinite;
        width: ${finalSize * 0.7}px;;
        height: ${finalSize * 0.7}px;;
        border-color: ${color} ${color} transparent transparent;
      }

      .loader::after{
        content: '';
        box-sizing: border-box;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border: 3px solid;
        border-color: transparent transparent ${color} ${color};
        border-radius: 50%;
        animation: rotationBack 0.7s linear infinite;
        transform-origin: center center;
      }

      .loader::before {
        border-color: inherit;
        animation: rotation 2s linear infinite;
        
      }

      .loader::after {
        width: 70%;
        height: 70%;
      }

      .loader::before {
        width: 60%;
        height: 60%;
      }

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes rotationBack {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(-360deg);
        }
      }
    `;

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);

    // Cleanup on unmount to remove the injected styles
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, [color, finalSize, props]); // Effect depends on color and finalSize

  return <span className="loader"></span>;
};

export default CustomLoaderIcon;
